import { Auth } from '@supabase/auth-ui-react';
import { ThemeSupa } from '@supabase/auth-ui-shared';
import { supabase } from './supabaseClient';

function Login() {
  
  return (
    <div
      style={{
        maxWidth: '400px',
        margin: '100px auto',
        textAlign: 'center',
        padding: '20px',
        backgroundColor: '#205D5E', // 👈 Page background color
        borderRadius: '5px',
        // boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.1)', // subtle shadow
      }}
    >
      {/* Your Logo on top */}
      <img
        src="https://greenlend.co.il/wp-content/uploads/2025/06/GreenlendLogo-White.png"
        alt="Logo"
        style={{
          width: '150px',
          marginBottom: '20px',
        }}
      />

      <p style={{ color: '#FFFFFF', marginBottom: '20px', marginTop: '-20px' }}>Task Manager</p>

      <Auth
        supabaseClient={supabase}
        providers={['google']}
        appearance={{
          theme: ThemeSupa,
          variables: {
            default: {
              colors: {
                brand: '#00B087',          // Main button color
                brandAccent: '#205D5E',     // Hover/focus
                inputBorder: '#205D5E',
                inputBackground: '#FFFFFF',
                messageText: '#FFFFFF',
                buttonText: '#FFFFFF',
              },
              fonts: {
                bodyFontFamily: 'Roboto, sans-serif',
                buttonFontFamily: 'Roboto, sans-serif',
              },
              radii: {
                inputBorderRadius: '5px',
                buttonBorderRadius: '5px',
              },
            },
          },
        }}
        redirectTo={window.location.origin}
      />
    </div>
  );
}

export default Login;
